import { isset as isDefined } from './utils';
import { modelVersions } from '../../services/constants';
import { analysisColumnKeys } from '../../store/constants';

const isset = (val) => isDefined(val) && val !== '';

const oneToOneDotFiveAnalysis = analysisColumnKeys.oneToOneDotFive;

const labels = {
    crop: 'gewas',
    stage: 'gewasstadium',
    teeltfase: 'teeltfase',
    substrate: 'substraat',
    drainAnalysis: 'drainanalyse',
    [oneToOneDotFiveAnalysis]: '1:1,5 analyse',
    dropWaterValue: 'EC irrigatie',
};

export const validateParameter = (parameter, value, allInput, modelVersion) => {
    switch (parameter) {
        case 'crop':
        case 'stage':
        case 'teeltfase':
        case 'dropWaterValue':
            // case "substrate":
            return {
                valid: isset(value),
                message: `${labels[parameter]} mag niet leeg zijn`,
            };
        case 'ionValues':
            // if (modelVersion === modelVersions.substraat && allInput.substrate ===)
            if (modelVersion === modelVersions.potplant) {
                return {
                    valid: isset(value?.pH?.[oneToOneDotFiveAnalysis]),
                    message: `De waarde van pH onder ${labels[oneToOneDotFiveAnalysis]} mag niet leeg zijn.`,
                };
                // return {
                //     valid:
                //         isset(value?.pH?.drainAnalysis) &&
                //         isset(value?.pH?.[oneToOneDotFiveAnalysis]),
                //     message: `De waarde van pH onder ${labels.drainAnalysis} en ${labels[oneToOneDotFiveAnalysis]} mag niet leeg zijn.`,
                // };
            }
            // when no values are filled in, we'll use the default streefwaarden from the settings
            const empty = Object.values(value).every((ionValues) =>
                Object.values(ionValues).every((val) => !val)
            );
            return {
                valid: isset(value?.pH?.drainAnalysis) || empty, // || isset(value?.pH?.[oneToOneDotFiveAnalysis]),
                message: `De waarde van pH onder ${labels.drainAnalysis} mag niet leeg zijn.`,
            };
        case 'ureum':
            const valid =
                !value.used || (isset(value.percentage) && isset(value.drain));
            let messages = [];
            if (!valid) {
                if (!isset(value.percentage))
                    messages.push(`%N-ureum mag niet leeg zijn`);
                if (!isset(value.drain))
                    messages.push(`ureum_drain mag niet leeg zijn`);
            }
            return {
                valid,
                message: messages.join(', '),
            };
        default:
            return { valid: true, message: '' };
    }
};

export const validateIfPresent = (
    input,
    parameter,
    valueIfNotpresent = true
) => {
    if (input.hasOwnProperty(parameter)) {
        return validateParameter(parameter, input[parameter]);
    }
    return valueIfNotpresent;
};

const validate = (input, modelVersion) => {
    const messages = Object.entries(input).reduce(
        (prev, [parameter, value]) => {
            const validation = validateParameter(
                parameter,
                value,
                input,
                modelVersion
            );
            if (validation.valid) {
                return prev;
            }
            return { ...prev, [parameter]: validation.message };
        },
        {}
    );
    return messages;
    //   return Object.entries(input).every(([parameter, value]) =>
    //     validateParameter(parameter, value)
    //   );
};

export default validate;
